import Vue from 'vue'
import router from './conf/router'
import App from './App.vue'
import store from './store/user.js'
import { sync } from 'vuex-router-sync'
import Login from './components/Login.vue'
import FastClick from 'fastclick'

import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

Raven
  .config('https://7057707d08954552aa7cfcc89d4d3899@sentry.io/130604')
  .addPlugin(RavenVue, Vue)
  .install()

sync(store, router)

FastClick.attach(document.body)

// 处理刷新的时候vuex被清空但是用户已经登录的情况
if (window.sessionStorage.user) {
  store.dispatch('setUserInfo', JSON.parse(window.sessionStorage.user))
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  ...App,
  store,
  Login
})



// WEBPACK FOOTER //
// ./src/main.js